import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { ApiService } from 'app/core/auth/api.service';

export interface DashboardStats {
    players_count: number;
    competitions_count: number;
    domains_count: number;
    current_edition_year: number;
}

export interface DashboardCompetition {
    id: number;
    name: string;
    code: string;
    state: string;
    d_day?: string;
    registrations_count?: number;
    participants_limit?: number;
    registration_opened?: boolean;
}

export interface DashboardAd {
    id: number;
    media_type: string;
    position: string;
    starts_at: string;
    ends_at: string;
    partner?: { name: string };
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
    constructor(private readonly http: ApiService) {}

    load(): Observable<{ stats: DashboardStats; competitions: { data: DashboardCompetition[] }; ads: DashboardAd[] }> {
        return forkJoin({
            stats: this.http.get('api/dashboard/stats'),
            competitions: this.http.get('api/dashboard/competitions?size=6'),
            ads: this.http.get('api/dashboard/partner-ads?limit=5'),
        });
    }
}
